// libs
import React, { useCallback, useState, memo } from 'react';

// components
import MobileHeaderContent from 'shared/components/Header/MobileHeaderProvider/MobileHeaderContent';

// styles
import { HeaderContainer, Title, AppHeaderContent, Placeholder } from './styles';

// context
import { useWishlistContext } from 'shared/layouts/Wishlist/API/context';

// constants
import { IOOptions } from 'shared/layouts/Listing/ListingMobile/components/Header/constants';
import { MIN_NUMBER_OF_PRODUCTS_TO_SHOW_PRODUCT_COUNT } from 'shared/layouts/Wishlist/Mobile/constants';
const TITLE = 'My wishlist';
const PRODUCTS = ' products';

//defs
interface IWishlistTitle {
  totalProductsInWishlist: number;
}
function WishlistTitle({ totalProductsInWishlist }: IWishlistTitle) {
  const [showHeaderTitle, setShowHeaderTitle] = useState(false);

  const { isFetching } = useWishlistContext();
  const onHeaderVisible = useCallback(() => {
    setShowHeaderTitle(false);
  }, []);

  const onHeaderHidden = useCallback(() => {
    setShowHeaderTitle(true);
  }, []);

  return (
    <>
      {totalProductsInWishlist === 0 && isFetching && <Placeholder />}
      {totalProductsInWishlist !== 0 && (
        <>
          <HeaderContainer
            options={IOOptions}
            onVisible={onHeaderVisible}
            onHidden={onHeaderHidden}
            data-test="wishlist-header-container"
          >
            <Title>
              {TITLE}
              {totalProductsInWishlist > MIN_NUMBER_OF_PRODUCTS_TO_SHOW_PRODUCT_COUNT && (
                <span className="count">
                  <span className="seperator" /> {totalProductsInWishlist}
                  {PRODUCTS}
                </span>
              )}
            </Title>
          </HeaderContainer>

          <MobileHeaderContent>
            {showHeaderTitle && (
              <AppHeaderContent>
                {TITLE}
                {totalProductsInWishlist > MIN_NUMBER_OF_PRODUCTS_TO_SHOW_PRODUCT_COUNT && (
                  <span className="count">
                    <span className="seperator" /> {totalProductsInWishlist}
                    {PRODUCTS}
                  </span>
                )}
              </AppHeaderContent>
            )}
          </MobileHeaderContent>
        </>
      )}
    </>
  );
}

export default memo(WishlistTitle);
